import Button, { ButtonWrapper } from 'blocks/Button';
import { Row } from 'blocks/CommonLayout';
import Form from 'components/Form';
import TextField from 'components/Form/TextField';
import Modal from 'components/Modal';
import { ModalFC } from 'config/types';
import { useState } from 'react';
import { useForm } from 'react-hook-form';
import { useTranslation } from 'react-i18next';
import ajax from 'utils/ajax';
import urls from 'utils/urls';
import { ModalEnterConfirmationFormModel } from './modalEnterConfirmation.interface';
import * as S from './modalEnterConfirmation.styles';

const ModalConfirmation: ModalFC<ModalEnterConfirmationFormModel> = ({
  open,
  onClose,
  setStatusPurchase,
  productBookingId,
  setShowModalProductPurchas,
}) => {
  const { register, handleSubmit } = useForm<any>();
  const { t } = useTranslation();
  const [loading, setLoading] = useState(false);

  const handleClose = () => {
    onClose && onClose();
  };
  const handleSendOtp = async (data) => {
    const newdata = {
      ...data,
      productBookingId: productBookingId.productBooking.id,
    };

    setLoading(true);
    const res = await ajax({
      url: urls.purchaseProduct,
      method: 'POST',
      data: newdata,
    }).finally(() => setLoading(false));

    if (!res) return;
    setStatusPurchase(res.productBooking);
    handleClose();
    setShowModalProductPurchas(true);
  };

  return (
    <Modal open={open} onClose={handleClose} width="400px">
      <S.Wrapper>
        <Row align="flex-end">
          <Form>
            <S.ffpInput>
              <TextField
                control={register('code')}
                label={t('pages.services.Products.sections.Card.fields.confirmationCode')}
              />
            </S.ffpInput>
            <S.ButtonWrapperSend as={ButtonWrapper} justify="center">
              <Button fullWidth width={200} onClick={handleSubmit(handleSendOtp)}>
                {t('pages.services.Products.sections.Card.sendBtn')}
              </Button>
            </S.ButtonWrapperSend>
          </Form>
        </Row>
      </S.Wrapper>
    </Modal>
  );
};

export default ModalConfirmation;
